.widget-container {
  position: relative;
  display: flex;
  justify-content: flex-end;
  padding: 0.8rem 1.6rem;
  border-radius: 0.4rem;
  background: var(--color-grayscale-tuna);
  order: 2;
  min-width: 0;

  @media screen and (min-width: $bp-medium) {
    border-radius: 0.4rem 0.4rem 0 0.4rem;
    padding: 2.4rem;
    order: unset;
  }
}

.weather-container {
  display: flex;
  position: relative;
  flex-direction: column;
  gap: 1.6rem;
  align-items: center;
  width: 100%;
}

.temperature {
  font-weight: 700;
  font-size: 2.4rem;
  color: var(--color-grayscale-athens);

  @media screen and (min-width: $bp-medium) {
    font-size: 4rem;
  }
}

.weather-wrapper {
  display: flex;
  gap: 1.2rem;

  @media screen and (min-width: $bp-medium) {
    gap: 3.2rem;
  }
}

.note-wrapper {
  width: 100%;
  padding: 0.8rem 1.6rem;
  background: var(--color-grayscale-tuna);
  border-radius: 0.4rem;
  order: 3;
  min-width: 0;

  @media screen and (min-width: $bp-medium) {
    border-radius: 0.4rem 0.4rem 0.4rem 0;
    order: unset;
    padding: 2.4rem;
  }
}

.note-header {
  font-weight: 400;
  font-size: 1.4rem;
  color: var(--color-grayscale-white);
  margin-bottom: 0.8rem;
}

.sun-data-wrapper {
  display: flex;
  gap: 0.8rem;
  align-items: center;
  font-weight: 500;
  font-size: 1.2rem;
  color: var(--color-grayscale-cadet);
  text-transform: capitalize;

  @media screen and (max-width: #{$bp-medium + 1}) {
    & > svg {
      width: 1.6rem;
      height: 1.6rem;
    }
  }

  @media screen and (min-width: $bp-medium) {
    font-size: 1.6rem;
  }
}

.sun-time {
  color: var(--color-grayscale-white);
}

.notes-input {
  border-radius: 0.4rem;
  border: 0.1rem solid var(--color-grayscale-trout);
  padding: 1.6rem;
  font-size: 1.4rem;
  line-height: 1.8rem;
  color: var(--color-grayscale-white);
  height: 10.6rem;

  position: relative;
  box-sizing: border-box;
  font-family: Inter, sans-serif;
  resize: none;
  background-color: transparent;

  &::placeholder {
    color: var(--color-grayscale-light-slate);
  }

  &:hover {
    background-color: var(--color-grayscale-arsenic);
    cursor: text;
  }

  &:focus {
    background-color: transparent !important;
    border-color: var(--color-grayscale-trout);
  }

  &[data-error='true'] {
    &:focus {
      border-color: var(--color-error);
    }
  }
}

.modified-button-wrapper {
  display: flex;
  gap: 1rem;

  position: absolute;
  top: 0.8rem;
  right: 1.6rem;
}
